// eslint-disable-next-line import/no-restricted-paths
import { Guest } from "@CHILLNN-Inc/chillnn-driver-reservation-react";
import { memo, useMemo } from "react";
import { generatePath, useNavigate } from "react-router";

import { AuthWrapper } from "@/lib/aws-amplify";

import { usePayjpClient } from "@/hooks/use-payjp-client";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

type Props = {
	hotelID: string;
};

const uri = import.meta.env.VITE_GRAPHQL_API_ENDPOINT_RESERVATION_HOST_DIRECT;

export const ManagementReservationAdd = memo(({ hotelID }: Props) => {
	const navigate = useNavigate();
	const { payjp } = usePayjpClient();

	const initializeContext = useMemo<Guest.ReservationComponent.Full.Props["initializeContext"]>(() => {
		return {
			sessionStateContext: {
				hotelID,
				lang: Guest.LangCode.Default,
			},
		};
	}, [hotelID]);

	const callbackContext = useMemo<Guest.ReservationComponent.Full.Props["callbackContext"]>(() => {
		return {
			onSuccessCallback: ({ hotelID, reservationID }) => {
				notifyUserEventInfo({
					variant: "default",
					title: "新規予約が完了しました",
				});

				const reservationDetailPagePath = generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.DETAIL, {
					hotelID,
					reservationID,
				});
				navigate(reservationDetailPagePath, { replace: true });
			},
			onHideCallback: () => {
				const path = generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.TOP, { hotelID });
				navigate(path, { replace: true });
			},
			onGetPayjpBackUrlCallback: () => () => "",
		};
	}, [hotelID, navigate]);

	const libContext = useMemo<Guest.ReservationComponent.Full.Props["libContext"]>(() => {
		return {
			apolloClient: {
				uri,
				getToken: async () => (await AuthWrapper.getIdToken()) ?? "",
			},
			payjp: {
				instance: payjp!,
			},
		};
	}, [payjp]);

	const envContext = useMemo<Guest.ReservationComponent.Full.Props["envContext"]>(() => {
		return {
			stage: import.meta.env.VITE_STAGE,
			user: "host",
		};
	}, []);

	return (
		<Guest.ReservationComponent.Full.Presenter
			initializeContext={initializeContext}
			callbackContext={callbackContext}
			libContext={libContext}
			envContext={envContext}
		/>
	);
});
